import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
export const useOtherUserEditingToast = (): ((id?: string) => void) => {
  const { t } = useTranslation();
  return useCallback(
    (id?: string) => {
      toast.error(t('canvas.editingUser.otherEditing'), {
        id,
        duration: 5000,
      });
    },
    [t]
  );
};
